import dynamic from 'next/dynamic';
import { styled } from '@mui/material/styles';
// const Slider = dynamic(() => import('@mui/material/Slider'), { ssr: false });
import Slider from '@mui/material/Slider';
const RangeSlider = styled(Slider)({
  color: '#176c5a',
  height: 12,
  '& .MuiSlider-track': {
    backgroundColor: '#7C5032',
    border: 'none',
  },

  '& .MuiSlider-rail': {
    backgroundColor: '#BDA798',
    opacity: 1,
  },

  '& .MuiSlider-thumb': {
    // width: 20,
    // height: 20,
    backgroundColor: '#7C5032',
    border: '2px solid #fff',

    '&:hover, &.Mui-focusVisible, &.Mui-active': {
      boxShadow: '0 0 0 8px rgba(124,80,50,0.2)',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    color: '#7C5032',
    width: 76,
    height: 25,
    backgroundColor: '#fff',
    border: '1px solid',
    transformOrigin: 'bottom left',
    '&:before': {
      border: '1px solid #7C5032',
      borderTop: 'none',
      borderLeft: 'none',
      zIndex: '-1',
      width: 12,
      height: 12,
    },
    '&.MuiSlider-valueLabelOpen': {},
  },
  '&.css-ttgsjq-MuiSlider-track': {
    backgroundColor: 'black',
  },
});
export default RangeSlider;
